
// Vue reactivity
import { defineComponent } from 'vue';

// Swiper
import 'swiper/swiper.min.css';
import '@ionic/vue/css/ionic-swiper.css';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue';
import { Zoom } from 'swiper';

// icons
import { close, arrowBack } from 'ionicons/icons';

// components
import { IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonButton, IonIcon,
        modalController, } from '@ionic/vue';

export default defineComponent({
  name: 'ImageModal',
  props: ["imageLink", "caption"],
  components: { Swiper, SwiperSlide, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonButton, IonIcon, },
  setup() {
    const closeModal = async () => { await modalController.dismiss() };

    return {
      // icons
      close,

      // methods
      closeModal,

      // variables
      modules: [Zoom],
    }
  }
});
